module.exports = __webpack_public_path__ + "img/2020_L.d4423c06.png";